import basicFlow, { genericErrorHandler } from './asyncHandler';
import {
  clear,
  consultaMassivaSantanderFailure,
  consultaMassivaSantanderRequest,
  consultaMassivaSantanderSuccess
} from '../reducers/consultaMassiva.reducer';
import { authenticatedRequest } from '../utils/api';
import { toast } from 'react-toastify';
import { routeWatcher } from './rotas.saga';
import { types as routes } from '../reducers/rotas.actions';
import { put } from 'redux-saga/effects';

const consultaMassivaApi = () => {
  return authenticatedRequest({
    url: '/santander/consulta-massiva',
    method: 'GET'
  });
};

const consultaMassiva = basicFlow({
  actionGenerator: consultaMassivaSantanderRequest,
  actionFailure: consultaMassivaSantanderFailure,
  actionSuccess: consultaMassivaSantanderSuccess,
  api: consultaMassivaApi,
  postSuccess: function (values) {
    toast.success(values);
  },
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

function* consultaMassivaRouteWatcher() {
  yield routeWatcher(routes.CONSULTA_MASSIVA_SANTANDER, function* () {
    yield put(clear());
  });
}

export const sagas = [consultaMassiva.watcher(), consultaMassivaRouteWatcher()];
